import React from 'react';

export function StepManufacturerSubjectLabel() {
  return <>Subjekt výrobce kotlů</>;
}
